<!--
   Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
-->

<div
  gta="attach-cluster-button__tooltip"
  [matTooltip]="(nebulaSubscription$ | async | map: isUnpaid) ? unpaidTooltip : ''"
  [matTooltipDisabled]="(disabled$ | async) === false"
>
  @if (template) {
    <ng-container
      *ngTemplateOutlet="template; context: { routerLink$: routerLink$, disabled$: disabled$ }"
    ></ng-container>
  } @else {
    <a
      *showForTarget="'on-premise'"
      mat-raised-button
      color="primary"
      [routerLink]="routerLink$ | async"
      gta="attach-cluster-button"
      >{{ text }}</a
    >
    <ng-container *showForTarget="'hosted'">
      @switch (type) {
        @case ('stroked') {
          <a
            mat-stroked-button
            color="primary"
            [routerLink]="routerLink$ | async"
            gta="attach-cluster-button"
            [disabled]="disabled$ | async"
          >
            {{ text }}
          </a>
        }
        @case ('raised') {
          <a
            mat-raised-button
            color="primary"
            [routerLink]="routerLink$ | async"
            gta="attach-cluster-button"
            [disabled]="disabled$ | async"
          >
            {{ text }}
          </a>
        }
      }
    </ng-container>
  }
</div>
